import React from 'react';
import css from './styles.module.scss';

interface ContentProps {}

export const Content: React.FC<ContentProps> = ({ children }) => {
    return <div className={css.module}>{children}</div>;
};
